import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error-triangle",
  "use": "icon-error-triangle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-error-triangle\">\n<path d=\"M8.00015 0.666687L15.9676 14.4667H0.0327148L8.00015 0.666687ZM2.34212 13.1334H13.6582L8.00015 3.33335L2.34212 13.1334ZM8.66658 6.33335V10H7.33325V6.33335H8.66658ZM7.33325 11H8.66919V12.336H7.33325V11Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol